import styled, { css } from 'styled-components';
import DataTable from '@components/Dashboard/components/DataTable';
import { RouterLink } from '@redux-first-router-link';
import {
  NameColumnHeader,
  TableHead,
} from '@/pages/Stocks/components/StockTable/styled';

import { media, buttonCSS, Ellipsis } from '@simplywallst/ui-core';

import type { ButtonProps } from '@simplywallst/ui-core';

export const Wrapper = styled('div')`
  margin-top: ${({ theme }) => theme.x2spacePx}px;
  margin-bottom: ${({ theme }) => theme.x3spacePx}px;
  > a {
    text-align: center;
  }
`;

export const Table = styled(DataTable)`
  border-bottom: 0;
  border-left: 0;
  border-right: 0;
  padding: 0;
  && {
    min-width: 550px;
  }
  th,
  td {
    &:last-child {
      text-align: left !important;
    }
  }
`;

export const Head = styled(TableHead)`
  th {
    background: ${({ theme }) => theme.color.noir} !important;
  }
`;

export const MarketCap = styled('span')`
  ${({ theme }) => theme.typography.tiny}
  padding: 0;
  color: ${({ theme }) => theme.color.whiteRGBA(0.5)};
`;

const NameColumn = styled('td')<{ isSticky: boolean }>`
  ${media.mdDown`
    position: sticky;
    left: -1px;
    z-index: 1;
    background: ${({ theme }) => theme.color.charcoal} !important;
    &:focus-within {
      background: ${({ theme }) => theme.color.noir} !important;
    }
    ${({ isSticky }) =>
      isSticky &&
      css`
        box-shadow: 2px 4px 4px ${({ theme }) => theme.color.almostBlack};
        border-right: 1px solid ${({ theme }) => theme.color.whiteRGBA(0.1)};
      `}
	`};
  color: ${({ theme }) => theme.color.whiteRGBA(0.5)};
  &,
  > a {
    ${media.mdDown`
      width: ${({ isSticky }) => (isSticky ? 95 : 146)}px;
    `};
    ${media.mdUp`
      width: 160px;
    `};
  }
  > a {
    flex-direction: column;
    justify-content: center;
    align-items: flex-start;
    > b {
      color: ${({ theme }) => theme.color.brand01};
      display: block;
    }
    > span {
      ${({ theme }) => theme.typography.tiny}
      ${Ellipsis}
      min-height: 16px;
      ${media.mdDown`
        min-height: 14px;
      `}
    }
  }
`;

export const NameColumnStyled = styled(NameColumn)`
  ${media.mdDown`
    background: ${({ theme }) => theme.color.noir} !important;
    ${({ isSticky }) =>
      isSticky &&
      css`
        box-shadow: 2px 0 4px ${({ theme }) => theme.color.almostBlack};
        border-right: 1px solid ${({ theme }) => theme.color.whiteRGBA(0.1)};
      `}
	`};
  max-width: 184px;

  > a {
    width: ${({ isSticky }) => (isSticky ? '95px' : '100%')};
  }
`;

export const NameColumnHeaderStyled = styled(NameColumnHeader)`
  width: ${({ isSticky }) => (isSticky ? 95 : 172)}px;
`;

export const SectorColumn = styled('td')`
  color: ${({ theme }) => theme.color.brand01};
  > a {
    > span {
      white-space: pre-wrap;
    }
  }
`;

export const DisabledSectorLink = styled('span')`
  opacity: 0.3;
  color: ${({ theme }) => theme.color.white} !important;
`;

export const SeeMoreButton = styled(RouterLink)<ButtonProps>`
  margin-top: ${({ theme }) => theme.x2spacePx}px;
  ${buttonCSS}
`;

export const SharePrice = styled('span')`
  ${({ theme }) => theme.typography.xSmall}
`;
